module.exports = __webpack_public_path__ + "static/media/homepage-contents.1ba92e02.svg";